export const getLanguageFromStorage = (): string => {
    const storedLanguage =
        localStorage.getItem('i18nextLng') ||
        sessionStorage.getItem('i18nextLng') ||
        localStorage.getItem('preferredLanguage') ||
        'hr' // Default to 'hr' if no language found

    return storedLanguage || 'hr' // Ensure we fall back to 'hr'
}
